import { useMemo } from "react";
import { NetworkStatus, useQuery } from "@apollo/client";
import { useDebounce } from "components/use-hooks";
import {
    adaptStaffAttendanceGroups,
    buildStaffAttendanceVariables,
    getStaffAttendanceModel,
    getStaffAttendanceQuery,
    paginateStaffAttendanceGroups,
    STAFF_ATTENDANCE_PAGE_SIZE,
} from "../helpers/staff-attendance-api-helper";


const useStaffAttendance = ({
    eeID,
    groupBy = "date",
    searchText = "",
    period = [],
    subcontractorID,
    page = 1,
    perPage = STAFF_ATTENDANCE_PAGE_SIZE,
}) => {
    const debouncedSearchText = useDebounce(searchText);
    const query = getStaffAttendanceQuery(groupBy);
    const model = getStaffAttendanceModel(groupBy);
    const variables = useMemo(() => buildStaffAttendanceVariables({
        eeID,
        searchText: debouncedSearchText,
        period,
        subcontractorID,
    }), [ debouncedSearchText, eeID, period, subcontractorID ]);
    const { data, loading, error, refetch, networkStatus } = useQuery(query, {
        skip: !variables.eeID,
        variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
    });
    const groups = useMemo(() => adaptStaffAttendanceGroups(
        data?.[ model ] || [],
        groupBy
    ), [ data, groupBy, model ]);
    const paginated = useMemo(() => paginateStaffAttendanceGroups(
        groups,
        page,
        perPage
    ), [ groups, page, perPage ]);

    return {
        ...paginated,
        loading,
        refreshing: networkStatus === NetworkStatus.refetch,
        refetch,
        error,
        query,
        variables,
    };
};

export default useStaffAttendance;
